module.exports = __webpack_public_path__ + "static/media/getStarted.02062261.jpg";